/**
 * @desc 接口文档
 * @see https://wiki.n.miui.com/pages/viewpage.action?pageId=559111687
 */

import { getMerchantInfo, getUserInfo } from '@/api/user'
import * as types from './mutation-types'

export const getMerchantData = async({ commit, state }, params) => {
  try {
    let info = await getMerchantInfo()
    const { code, data, msg } = info
    if (code !== 0) throw Error(msg)
    // 入驻阶段
    if (data.enterState) commit(types.SET_ENTER_STATE, data.enterState)
    // 签署协议阶段
    if (data.signState) commit(types.SET_SIGN_STATE, data.signState)
    // 协议数据
    if (data.signData) commit(types.SET_SIGN_DATA, data.signData)
    // 加签日志
    if (data.operationLog) commit(types.SET_OPERATION_LOG, data.operationLog)
    if (data.enterState === 'FRESHMAN') {
      // 未入驻
      commit(types.SET_STEP_INDEX, 0)
      commit(types.SET_CONTACT_INDEX, 0)
    } else if (data.enterState === 'CHECKING' || data.enterState === 'NEED_MODIFY') {
      // 资质审核
      commit(types.SET_ISOVERSEAS, data.enterData.merchantType === 1)
      commit(types.SET_APPLICATION_ID, data.applicationId)
      let duration = 0
      if (data.reviewDuration > 48 * 3600) duration = 0
      else if (data.reviewDuration > 24 * 3600) duration = 24
      else duration = 48
      commit(types.SET_REVIEW_DURATION, duration)
      commit(types.SET_STEP_INDEX, 3)
    } else if (data.enterState === 'SIGNING') {
      // 合作协议签署
      commit(types.SET_ISOVERSEAS, data.enterData.merchantType === 1)
      commit(types.SET_APPLICATION_ID, data.applicationId)
    } else if (data.enterState === 'ENTERED') {
      // 已入驻
      commit(types.SET_STEP_INDEX, 4)
    }
    if (data.enterData) {
      const d = data.enterData
      const m = {}
      // 合并普通和海外商家数据
      if (d.contact) m.contact = d.contact
      else if (d.overseaContact) m.contact = d.overseaContact
      if (d.company) m.company = d.company
      else if (d.overseaCompany) m.company = d.overseaCompany
      if (d.legal) m.legal = d.legal
      if (d.category) m.category = d.category
      if (d.brand) m.brand = d.brand
      // 保存已填数据
      commit(types.SET_MERCHANT_DATA, m)
      if (data.enterState === 'IN_PROGRESS') {
        const isOverseas = data.enterData.merchantType === 1
        if (state.isOverseas !== isOverseas) {
          // 入驻类型和所填不符合则从开头重新提交
          commit(types.SET_STEP_INDEX, 0)
          commit(types.SET_CONTACT_INDEX, 0)
        } else {
          if (m.category) commit(types.SET_STEP_INDEX, 2)
          else if (m.legal) commit(types.SET_STEP_INDEX, 1)
          else if (m.company) {
            commit(types.SET_STEP_INDEX, 0)
            commit(types.SET_CONTACT_INDEX, 2)
          } else if (m.contact) {
            commit(types.SET_STEP_INDEX, 0)
            commit(types.SET_CONTACT_INDEX, 1)
          }
        }
      }
    }
    return state.stepIndex === 4
  } catch (e) {
    throw Error(e)
  }
}

export const getLoginStatus = async({ commit, state }, flag) => {
  try {
    const info = await getUserInfo()
    if (!info.code) {
      commit(types.LOGIN_STATUS, true)
    } else {
      commit(types.LOGIN_STATUS, false)
    }
    return info
  } catch (e) {
    throw Error(e)
  }
}
